class Citation {
    constructor (context, settings, $, ClipboardJS, selector) {
        this.context = context;
        this.settings = settings;
        this.$ = $;
        this.$window = this.$(window);

        this.$window.on('load', () => {
            this.initClipboard(selector, this.$, ClipboardJS);
        });
    }

    initClipboard (selector, $, ClipboardJS) {
        const clipboard = new ClipboardJS(selector);

        clipboard.on('success', function (e) {
            const $elem = $(e.trigger);
            const $elemText = $elem.find('span');

            $elem.addClass('has-copied');
            $elemText.text('Copied!');

            setTimeout(() => {
                if ($elem.hasClass('has-copied')) {
                    $elemText.text('Copy to clipboard').removeClass('has-copied');
                }
            }, 2500);
            e.clearSelection();
        });
    }
}

export default Citation;
